// Firmware distribution (SaaS): released firmware images + gateway image
// management (install / system images / default-boot). S3-backed and gated out of
// the backend, so the API functions here are trial-aliased to no-ops and the
// Gateways UI for them is hidden. Only the API calls (and their endpoint paths)
// move out of the page; the (kept) useQuery/useMutation wrappers stay in Gateways.
import axios from 'axios';
import { config } from '@/config.ts';

const backendApi = config.backendApi;

export interface FirmwareImage {
  id: string;
  version: string;
  filename: string;
  architecture: string;
  released: boolean;
  sizeBytes: number;
}

export interface SystemImage {
  name: string;
  isRunning: boolean;
  isDefaultBoot: boolean;
}

interface FirmwareImageListResponse {
  firmwareImages: FirmwareImage[];
}

interface SystemImagesResponse {
  images: SystemImage[];
}

interface MutationResult {
  success: boolean;
  message: string;
}

export const fetchReleasedFirmwareImages = async (): Promise<FirmwareImage[]> => {
  const response = await axios.get<FirmwareImageListResponse>(`${backendApi}/api/firmware-images/released`, {
    withCredentials: true,
  });
  return response.data.firmwareImages;
};

export const fetchSystemImages = async (gatewayId: string): Promise<SystemImage[]> => {
  const response = await axios.get<SystemImagesResponse>(`${backendApi}/api/gateways/${gatewayId}/system-images`, {
    withCredentials: true,
  });
  return response.data.images;
};

export const setDefaultBoot = async (data: { gatewayId: string; imageName: string }): Promise<MutationResult> => {
  const response = await axios.post<MutationResult>(
    `${backendApi}/api/gateways/${data.gatewayId}/set-default-boot-image`,
    { imageName: data.imageName },
    { withCredentials: true },
  );
  return response.data;
};
